import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import customDecodeUri from '@/utils/customDecodeUri'
import { splitFilename } from '@/modules/_helpers/splitFilename'
import { TextInput } from '@/modules/base/components/inputs/index'
import { FORBIDDEN_FILENAME_CHARACTERS } from '@/modules/base/util/constants'

const useStyles = makeStyles((theme) => ({
  input: {
    '& ::placeholder': { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: theme.black,
      opacity: 1,
    },
  },
}))

const FilenameInput = (props) => {
  const classes = useStyles(props)

  const { isFileRenameOn, file, onUpdate, key = 'name' } = props

  const [value, setValue] = useState(isFileRenameOn ? splitFilename(file.name).name : '')
  const [name, setName] = useState(file.name)

  useEffect(() => {
    setName(file.name)
  }, [file.name])

  const onBlur = (e) => {
    setName(`${e}${splitFilename(file.name).suffix}`)
    setValue('')
    if (e === splitFilename(file.name).name) {
      return
    }
    onUpdate(e, key)
  }

  return (
    <TextInput
      className={classes.input}
      useFormik={false}
      label={lang.generics.name}
      placeholder={customDecodeUri(name)}
      value={value}
      autoFocus={isFileRenameOn}
      selectOnFocus
      onFocus={() => setValue(splitFilename(name).name)}
      onBlur={onBlur}
      invalidCharacters={FORBIDDEN_FILENAME_CHARACTERS}
    />
  )
}

FilenameInput.propTypes = {
  isFileRenameOn: PropTypes.bool,
  file: PropTypes.object,
  key: PropTypes.string,
  onUpdate: PropTypes.func,
}

export default FilenameInput
